import { useMemo, useState } from 'react'
import { SYSTEM_TYPE, useSystemStore } from '@/app/store/systemStore'
import { useGeliosStore } from '@/app/store/geliosStore'
import { useFortMonitorStore } from '@/app/store/fortmonitorStore'
import { useGlonassoftStore } from '@/app/store/glonassoftStore'
import {
  WIALON_DEFAULT_URL,
  OMNICOMM_DEFAULT_URL,
  AXENTA_DEFAULT_URL,
  GELIOS_DEFAULT_URL,
  FORTMONITOR_DEFAULT_URL,
  GLONASSOFT_DEFAULT_URL,
} from '@/shared/config/systemUrls'

export const useSystemUrl = () => {
  const selectedSystem = useSystemStore((s) => s.selectedSystem)
  const geliosServer = useGeliosStore((s) => s.server)
  const fortMonitorServer = useFortMonitorStore((s) => s.server)
  const glonassoftServer = useGlonassoftStore((s) => s.server)

  // Ручной ввод хоста, актуален только для Wialon/Omnicomm/Axenta —
  // Gelios/FortMonitor/Glonassoft берут host из своего стора, manualUrl для них не используется.
  const [manualUrl, setManualUrl] = useState(() => {
    if (selectedSystem === SYSTEM_TYPE.WIALON) return WIALON_DEFAULT_URL
    if (selectedSystem === SYSTEM_TYPE.OMNICOMM) return OMNICOMM_DEFAULT_URL
    if (selectedSystem === SYSTEM_TYPE.AXENTA) return AXENTA_DEFAULT_URL
    return ''
  })

  const systemUrl = useMemo(() => {
    if (selectedSystem === SYSTEM_TYPE.GELIOS) {
      return geliosServer || GELIOS_DEFAULT_URL
    }
    if (selectedSystem === SYSTEM_TYPE.FORTMONITOR) {
      return fortMonitorServer || FORTMONITOR_DEFAULT_URL
    }
    if (selectedSystem === SYSTEM_TYPE.GLONASSOFT) {
      return glonassoftServer || GLONASSOFT_DEFAULT_URL
    }

    // TODO: Omnicomm и Axenta не учитывают server из своих стор (omnicommStore/axentaStore),
    // используется только статичный дефолт через manualUrl. Если потребуется кастомный
    // server для них — добавить ветки по аналогии с Gelios/FortMonitor.
    return manualUrl
  }, [
    selectedSystem,
    manualUrl,
    geliosServer,
    fortMonitorServer,
    glonassoftServer,
  ])

  return { systemUrl, setSystemUrl: setManualUrl }
}
